export const isSwedishLetter = (char: string) => {
  return ['å', 'ä', 'ö'].includes(char.toLowerCase());
};
